import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, Checkbox, FormControl, InputLabel, Select, MenuItem, IconButton, ListItemText, Menu, Card, CardHeader, CardContent } from "@mui/material"
import Layout from "../components/Layout"
import { Container } from "../components/Container"
import { useForm, Controller } from "react-hook-form"
import { PetModal } from "../components/PetModal"
import { useEffect, useState } from "react"
import { CompanyServicesAPI } from "../api/CompanyServicesAPI"
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { toast } from "react-toastify"
import { FilterCompanyService } from "../components/FilterCompanyService"
import { formatBRL } from "../components/utils/format"
import { isMobile } from "react-device-detect"

export const CompanyServices = () => {
    const [rows, setRows] = useState([]);
    const [status, setStatus] = useState([]);
    const [openModalServices, setOpenModalServices] = useState(false)
    const [openEditModal, setOpenEditModal] = useState(false);

    const defaultValues = {
        name: '',
        cost: '',
        custom_status_id: null,
        active: true,
        description: '',
        hours: '',
        minutes: ''
    }
    const methods = useForm({ defaultValues })
    const methodsEdit = useForm({ defaultValues })
    const watchedStatusId = methodsEdit.watch("custom_status_id")


    const openModalNewServices = () => {
        setOpenModalServices(true);
        methods.reset();
    }

    const loadData = async (data) => {
        const result = await CompanyServicesAPI.getServices(data)
        if (result.success) {
            setRows(result.data.services)
            setStatus(result.data.statusOptions)
        }
    }
    useEffect(() => {
        loadData();
    }, []);

   

    const parseBRLToNumber = (costStr) => {
        const cleaned = costStr.replace(/\D/g, '');
        return cleaned ? parseFloat(cleaned) / 100 : 0;
    };

    const submit = async (data) => {

        const hours = data.hours
        const minutes = data.minutes

        const totalOfMinutes = ((Number(hours) * 60) + (Number(minutes) ? Number(minutes) : 0))

        const cost = parseBRLToNumber(data.cost);

        const body = {
            name: data.name,
            description: data.description,
            cost: cost,
            active: data.active,
            duration_minutes: totalOfMinutes,
            custom_status_id: data.custom_status_id
        }
        const result = await CompanyServicesAPI.createService(body)

        if (result.success) {
            setOpenModalServices(false);
            methods.reset(defaultValues);
            loadData();
            return toast.success(result.message);
        } else {
            return toast.error(result.message);
        }
    }

    const [anchorEl, setAnchorEl] = useState(null);

    const handleMenuClick = (event, row) => {
        setAnchorEl(event.currentTarget);
        const hours = Math.floor(row.duration_minutes / 60);
        const minutes = row.duration_minutes % 60;

        methodsEdit.reset({
            id: row.id,
            name: row.name,
            cost: formatBRL(Math.round(row.cost * 100).toString()),
            custom_status_id: row.custom_status?.id,
            active: row.active,
            description: row.description,
            hours: hours,
            minutes: minutes,
        })
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const submitEdit = async (data) => {

        const totalOfMinutes = ((Number(data.hours) * 60) + (Number(data.minutes) ? Number(data.minutes) : 0))
        const cost = parseBRLToNumber(data.cost);
        const body = {
            name: data.name,
            cost: cost,
            custom_status_id: data.custom_status_id,
            active: data.active,
            description: data.description,
            duration_minutes: totalOfMinutes,
            id: data.id,
        }
        const result = await CompanyServicesAPI.updateService(body)
        if (result.success) {
            setOpenEditModal(false);
            methodsEdit.reset(defaultValues);
            loadData();
            return toast.success(result.message);
        } else {
            return toast.error(result.message);
        }
    }


    const handleDeleteService = async () => {

        if (!methodsEdit.getValues("id")) {
            return toast.error("Serviço não encontrado");
        }
        const body = {
            id: methodsEdit.getValues("id"),
        }
        const result = await CompanyServicesAPI.deleteService(body)
        if (result.success) {
            loadData();
            return toast.success(result.message);
        } else {
            return toast.error(result.message);
        }
    }

    const formatDuration = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hours > 0 && mins > 0) {
            return `${hours} hora${hours > 1 ? 's' : ''} e ${mins} minutos`;
        } else if (hours > 0) {
            return `${hours} hora${hours > 1 ? 's' : ''}`;
        } else {
            return `${mins} minutos`;
        }
    };

    return (
        <>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    sx: {
                        minWidth: 200,
                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
                    },
                }}
            >
                <MenuItem onClick={() => { setOpenEditModal(true); handleMenuClose() }}>
                    <ListItemText
                        primary="Editar"
                        primaryTypographyProps={{
                            fontSize: '0.875rem',
                        }}
                    />
                </MenuItem>
                <MenuItem onClick={() => { handleDeleteService(); handleMenuClose() }}>
                    <ListItemText
                        primary="Excluir"
                        primaryTypographyProps={{
                            fontSize: '0.875rem',
                        }}
                    />
                </MenuItem>
            </Menu>

            <PetModal
                open={openEditModal}
                onClose={() => setOpenEditModal(false)}
                title="Editar Serviço"
                size={'medium'}
                formId='company-service-edit-form'
            >
                <form id='company-service-edit-form' onSubmit={methodsEdit.handleSubmit(submitEdit)}>
                    <Box display='flex' flexDirection='column' className='gap-1'>
                        <Box display='flex' flexDirection='column' className='gap-1'>
                            <TextField
                                id="outlined-basic"
                                label="Nome"
                                variant="outlined"
                                name="name"
                                {...methodsEdit.register("name")}
                            />
                        </Box>
                        <Box display='flex' flexDirection='column' className='gap-1'>
                            <TextField
                                id="outlined-basic"
                                label="Descrição"
                                variant="outlined"
                                name="description"
                                {...methodsEdit.register("description")}
                            />
                        </Box>
                        <Box display='flex' flexDirection='column' className='gap-1'>
                            <Controller
                                name="cost"
                                control={methodsEdit.control}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        id="outlined-basic"
                                        label="Custo"
                                        variant="outlined"
                                        onChange={(e) => {
                                            const formatted = formatBRL(e.target.value);
                                            field.onChange(formatted);
                                        }}
                                        placeholder="R$ 0,00"
                                    />
                                )}
                            />
                        </Box>

                        <Box display='flex' flexDirection='column' className='gap-1'>

                            <TextField
                                id="outlined-basic"
                                label="Horas"
                                variant="outlined"
                                name="hours"
                                {...methodsEdit.register("hours")}
                            />
                            <TextField
                                id="outlined-basic"
                                label="Minutos"
                                variant="outlined"
                                name="minutes"
                                {...methodsEdit.register("minutes")}
                            />

                        </Box>
                        <Box display='flex' flexDirection='column' className='gap-1'>
                            <FormControl variant="outlined">
                                <InputLabel id="status-label">Status inicial</InputLabel>
                                <Select
                                    labelId="status-label"
                                    id="status"
                                    name="status"
                                    label="Status inicial"
                                    value={watchedStatusId || ''}
                                    onChange={(e) => methodsEdit.setValue("custom_status_id", e.target.value)}
                                >
                                    {status.map((s) => (
                                        <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                        <Box display='flex' flexDirection='row' className='gap-1' alignItems='center'>
                            <Checkbox
                                id="outlined-basic"
                                label="Ativo"
                                name="active"
                                {...methodsEdit.register("active")}
                                checked={methodsEdit.watch("active")}
                                onChange={(e) => methodsEdit.setValue("active", e.target.checked)}
                            />
                            <Typography>Ativo</Typography>

                        </Box>
                    </Box>
                </form>
            </PetModal>

            <PetModal
                open={openModalServices}
                onClose={() => setOpenModalServices(false)}
                title="Novo Serviço"
                size={'medium'}
                formId='company-service-form'
            >
                <form id='company-service-form' onSubmit={methods.handleSubmit(submit)}>
                    <Box display='flex' flexDirection='column' className='gap-1'>
                        <TextField
                            id="outlined-basic"
                            label="Nome"
                            variant="outlined"
                            name="name"
                            {...methods.register("name")}
                            required
                        />
                        <TextField
                            id="outlined-basic"
                            label="Descrição"
                            variant="outlined"
                            name="description"
                            {...methods.register("description")}
                            required
                        />
                        <Controller
                            name="cost"
                            control={methods.control}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    id="outlined-basic"
                                    label="Custo"
                                    variant="outlined"
                                    required
                                    onChange={(e) => {
                                        const formatted = formatBRL(e.target.value);
                                        field.onChange(formatted);
                                    }}
                                    placeholder="R$ 0,00"
                                />
                            )}
                        />
                        <Typography color='primary.main' fontWeight='bold'>
                            Duração
                        </Typography>

                        <Box display='flex' gap={1}>
                            <TextField
                                id="company-city"
                                label="Horas"
                                variant="outlined"
                                name="hours"
                                type="number"
                                {...methods.register("hours")}
                            />

                            <TextField
                                id="company-state"
                                label="Minutos"
                                variant="outlined"
                                name="minutes"
                                type="number"
                                {...methods.register("minutes")}
                            />

                            <Box display='flex' flexDirection='row' className='gap-1' alignItems='center'>
                                <Checkbox
                                    id="outlined-basic"
                                    label="Ativo"
                                    name="active"
                                    onChange={(e) => methods.setValue("active", e.target.checked)}
                                    checked={methods.watch("active")}
                                />
                                <Typography>Ativo</Typography>
                            </Box>
                        </Box>

                        <FormControl variant="outlined">
                            <InputLabel id="status-label">Status inicial</InputLabel>
                            <Select
                                labelId="status-label"
                                id="status"
                                name="status"
                                label="Status inicial"
                                value={methods.watch("custom_status_id") || ''}
                                onChange={(e) => methods.setValue("custom_status_id", e.target.value)}
                            >
                                {status.map((s) => (
                                    <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </form>

            </PetModal>
            <Layout height="calc(100vh - 100px)">
                <Box marginBottom='10px'>
                    <Typography variant="h4" component="h1" color="primary">
                        Serviços
                    </Typography>
                </Box>

                <Box marginBottom="10px" width="100%" display="flex" justifyContent="flex-end" className="gap-1">
                    <Button
                        style={{ textTransform: "none" }}
                        color="primary"
                        variant="contained"
                        onClick={() => openModalNewServices()}
                    >
                        <Typography>
                            Novo Serviços
                        </Typography>
                    </Button>
                    <FilterCompanyService onFilter={loadData} status={status} />
                </Box>

                <Box display={{ xs: 'block', sm: 'none' }}>
                    {rows.length === 0 ? (
                        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="200px" sx={{ color: '#9CA3AF' }}>
                            <Typography variant="body1" color="textSecondary">
                                Nenhum serviço encontrado
                            </Typography>
                        </Box>
                    ) : (
                        rows.map((row) => (
                            <Card key={row.id} sx={{ mb: 2, borderRadius: 2, boxShadow: 3 }}>
                                <CardHeader
                                    title={
                                        <Typography variant="subtitle1" fontWeight={600}>
                                            {row.name}
                                        </Typography>
                                    }
                                    action={
                                        <IconButton
                                            onClick={(event) => handleMenuClick(event, row)}
                                            size="small"
                                        >
                                            <MoreHorizIcon />
                                        </IconButton>
                                    }
                                />
                                <CardContent>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            ID:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.id}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Custo:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.cost.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Descrição:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.description}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} mb={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Duração:
                                        </Typography>
                                        <Typography variant="body2">
                                            {formatDuration(row.duration_minutes)}
                                        </Typography>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1}>
                                        <Typography variant="body2" color="textSecondary">
                                            Ativo:
                                        </Typography>
                                        <Typography variant="body2">
                                            {row.active ? 'Ativo' : 'Inativo'}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        ))
                    )}
                </Box>

                <Container isMobile={isMobile}>
                    <Box display={{ xs: 'none', sm: 'block' }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ width: '100%', height: '100%', overflowY: 'auto' }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ID</TableCell>
                                        <TableCell>Nome</TableCell>
                                        <TableCell>Custo</TableCell>
                                        <TableCell>Descrição</TableCell>
                                        <TableCell>Duração</TableCell>
                                        <TableCell>Ativo</TableCell>
                                        <TableCell align="right">Ações</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.length > 0 ? (
                                        rows.map((row, index) => (
                                            <TableRow
                                                key={row.id || index}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {row.id}
                                                </TableCell>
                                                <TableCell>{row.name}</TableCell>
                                                <TableCell>{row.cost.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</TableCell>
                                                <TableCell>{row.description}</TableCell>
                                                <TableCell>{formatDuration(row.duration_minutes)}</TableCell>
                                                <TableCell>{row.active ? 'Ativo' : 'Inativo'}</TableCell>
                                                <TableCell align="right">
                                                    <IconButton
                                                        onClick={(event) => handleMenuClick(event, row)}
                                                        size="small"
                                                    >
                                                        <MoreHorizIcon />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={7} align="center">

                                                'Nenhum serviço encontrado'

                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Container>
            </Layout>
        </>
    )
}